import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "service-charge-wrap bg-stratos pt-20 pb-20" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
  /*#__PURE__*/_createElementVNode("span", null, "SIMULATEUR"),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-white" }, "Lancez dès maintenant votre simulation")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link active",
      id: "estimationPret-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#estimationPret",
      type: "button",
      role: "tab",
      "aria-controls": "estimationPret",
      "aria-selected": "true"
    }, "Estimation d'envoi de colis ")
  ])
], -1)
const _hoisted_8 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_9 = {
  class: "tab-pane fade show active",
  id: "estimationPret",
  role: "tabpanel",
  "aria-labelledby": "estimationPret-tab"
}
const _hoisted_10 = {
  class: "row pt-50",
  id: ""
}
const _hoisted_11 = { class: "col-lg-7" }
const _hoisted_12 = { class: "row justify-content-center mb-10" }
const _hoisted_13 = { class: "col-lg-4 col-md-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "send_money" }, "TYPE D'ENVOI", -1)
const _hoisted_16 = { class: "col-lg-8 col-md-8" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "recieved_money" }, "DISTANCE", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "col-lg-4 col-md-4" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "recieved_money" }, "POIDS DU COLIS", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8 col-md-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "recieved_money" }),
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn style1 w-100 mt-3"
    }, "Obtenir l'estimation")
  ])
], -1)
const _hoisted_24 = {
  key: 0,
  class: "col-lg-5"
}
const _hoisted_25 = {
  class: "card",
  style: {"background-color":"#00519e","color":"white !important","border-color":"white"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", {
  class: "texte-center",
  style: {"text-align":"center","color":"white"}
}, "POINT DE L'ESTIMATION", -1)
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "card-subtitle mb-3 text-white" }
const _hoisted_29 = { style: {"color":"#fec329","float":"right"} }
const _hoisted_30 = { class: "card-subtitle mb-3" }
const _hoisted_31 = { style: {"color":"#fec329","float":"right"} }
const _hoisted_32 = { class: "card-subtitle mb-3 text-white" }
const _hoisted_33 = { style: {"color":"#fec329","float":"right","clear":"both"} }
const _hoisted_34 = { class: "card-subtitle mb-3" }
const _hoisted_35 = { style: {"color":"#fec329","float":"right"} }
const _hoisted_36 = {
  key: 1,
  class: "col-lg-5"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "card",
  style: {"background-color":"#00519e","color":"white !important","border-color":"white"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }),
  /*#__PURE__*/_createElementVNode("h6", {
    class: "texte-center",
    style: {"text-align":"center","color":"white"}
  }, "Ici, vous pouvez calculer les frais approximatifs pour recevoir vos colis au Bénin et partout dans le monde. Les valeurs calculées sont estimées et leur utilisation est référentielle. "),
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" })
], -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Form, {
                      onSubmit: _ctx.checkEstimation,
                      "validation-schema": _ctx.estimationSchema,
                      class: "charge-form"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _createVNode(_component_Field, {
                                name: "type",
                                class: "form-control shadow-none fs-md-15 text-dark",
                                style: {"background-color":"black","font-weight":"bold"}
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_component_Multiselect, _mergeProps({
                                    style: {"color":"black","font-weight":"bold"},
                                    options: _ctx.typeValue,
                                    searchable: true,
                                    "track-by": "label",
                                    label: "label",
                                    modelValue: field.value,
                                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                  }, field, {
                                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.typeChange($event))),
                                    placeholder: "Sélectionner le type"
                                  }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_ErrorMessage, {
                              name: "type",
                              class: "text-danger",
                              style: {"font-weight":"bold"}
                            })
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createVNode(_component_Field, {
                                name: "distance",
                                style: {"background-color":"black"},
                                class: "form-control shadow-none fs-md-15 text-white"
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_component_Multiselect, _mergeProps({
                                    style: {"color":"black","font-weight":"bold"},
                                    options: _ctx.distanceOptions,
                                    searchable: true,
                                    "track-by": "label",
                                    label: "label",
                                    modelValue: _ctx.distanceSelect,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.distanceSelect) = $event))
                                  }, field, {
                                    noOptionsText: "Sélectionner d'abord un type d'envoi",
                                    placeholder: "Sélectionner la distance"
                                  }), null, 16, ["options", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_ErrorMessage, {
                              name: "distance",
                              class: "text-danger",
                              style: {"font-weight":"bold"}
                            }),
                            _createTextVNode(),
                            _hoisted_19
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _createVNode(_component_Field, {
                                name: "poids",
                                type: "number",
                                id: "recieved_money",
                                class: "form-control shadow-none fs-md-15 text-black",
                                style: {"font-weight":"bold","background-color":"white"},
                                placeholder: "en g"
                              })
                            ]),
                            _createVNode(_component_ErrorMessage, {
                              name: "poids",
                              class: "text-danger",
                              style: {"font-weight":"bold"}
                            })
                          ]),
                          _hoisted_23
                        ])
                      ]),
                      _: 1
                    }, 8, ["onSubmit", "validation-schema"])
                  ]),
                  (_ctx.type || _ctx.poids || _ctx.distance)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("h6", _hoisted_28, [
                              _createTextVNode("TYPE D'ENVOI : "),
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.type == 1 ? "Colis postaux" : _ctx.type == 2 ? "Envois express" : _ctx.type == 3 ? "Poste aux lettres" : _ctx.type == 4 ? "Transfert et Location" : ""), 1)
                            ]),
                            _createElementVNode("h6", _hoisted_30, [
                              _createTextVNode("POIDS DU COLIS : "),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.poids) + " g", 1)
                            ]),
                            _createElementVNode("h6", _hoisted_32, [
                              _createTextVNode("DISTANCE :"),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.distance), 1)
                            ]),
                            _createElementVNode("h6", _hoisted_34, [
                              _createTextVNode("MONTANT TOTAL : "),
                              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.montant) + " FCFA", 1)
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}